import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'design-system/Modal';
import { getCurrentSessionURL } from 'react-scale/lib/fullstory';

const FullstoryCheckModal: React.FC = () => {
  const [fullstoryEnabled, setFullstoryEnabled] = useState(true);

  useEffect(() => {
    // check if fullstory is enabled every second
    const interval = setInterval(() => {
      setFullstoryEnabled(getCurrentSessionURL(true) !== undefined);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Modal
      isOpen={!fullstoryEnabled}
      contentLabel="Activity Tracking Compliance Check"
      maxWidth="800px"
    >
      <ModalHeader>Activity Tracking Compliance Check</ModalHeader>
      <ModalBody>Please disable any adblockers and refresh the page.</ModalBody>
    </Modal>
  );
};

export default FullstoryCheckModal;
